"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CommonPrefix_1 = require("./_CommonPrefix");
exports._CommonPrefixList = {
    type: "list",
    flattened: true,
    member: {
        shape: _CommonPrefix_1._CommonPrefix
    }
};
//# sourceMappingURL=_CommonPrefixList.js.map